export const faqs = [
  {
    question: 'What is EarnestBridge and who is it best for?',
    answer: 'EarnestBridge is an earnest money deposit (EMD) financing platform for deal-makers who need to lock up deals without tying up their own capital. It is best for commercial real estate investors, M&A buyers, aviation purchasers, government contractors, oil & gas operators, and maritime buyers who regularly submit earnest money deposits and want to preserve liquidity across multiple simultaneous deals.',
  },
  {
    question: 'What types of commercial real estate deals does EarnestBridge fund?',
    answer: 'We fund EMDs for multifamily, office, industrial, retail, mixed-use, and hospitality deals across the US.',
  },
  {
    question: 'Do I need a personal guarantee?',
    answer: 'No, a personal guarantee is not required. We evaluate the deal structure, property, and market — your personal assets are not at risk.',
  },
  {
    question: 'Do I have to pay back the EMD?',
    answer: 'No, there is no repayment obligation of the EMD if you choose to not exercise the option, provided however, in the event of a default of any of the agreements with Earnest Bridge you have indemnification obligations.',
  },
  {
    question: 'How is the fee structured?',
    answer: 'We charge two fees: (1) a flat Administrative Fee of $2,500 and (2) a Deal Fee based on the EMD amount and the duration of the funding period. Fees are disclosed upfront in the funding agreement with no hidden charges.',
  },
  {
    question: 'When is repayment due?',
    answer: 'Repayment of the EMD plus our fee is due at closing. If the deal falls through and the EMD is returned, repayment is due when the funds are released from escrow.',
  },
  {
    question: 'What if I need the EMD funded in less than 24 hours?',
    answer: 'Expedited funding is available in select cases. Contact us directly via email at deals@earnestbridge.com to discuss rush requests.',
  },
  {
    question: 'Can I use EarnestBridge for multiple deals simultaneously?',
    answer: "Yes — that\'s one of our core use cases. Many of our clients run multiple concurrent acquisitions and use EarnestBridge to deploy EMDs across all of them without tying up equity.",
  },
  {
    question: 'Which states does EarnestBridge not cover?',
    answer: 'EarnestBridge does not currently provide EMD financing for deals located in California, Hawaii, Utah, Vermont, or Kansas. If your deal is in one of these states, please contact us at deals@earnestbridge.com — we are happy to discuss your situation and explore any available options.',
  },
  {
    question: 'Why should I choose EarnestBridge over alternatives?',
    answer: 'EarnestBridge is purpose-built for EMD financing — not a general lender, not an equity partner. We operate as a silent funding partner, require no personal guarantee, no credit check, and no long-term commitment. Our 1-page application and 24–48 hour funding timeline means you never miss a deal window. Unlike self-funding or relying on equity investors, EarnestBridge lets you scale your deal pipeline without diluting your capital or giving up leverage.',
  },
];
